// extracted by css-extract-rspack-plugin
export default {"container":"container-tu02yI","header":"header-RELelc","content":"content-kPyGPS","divider":"divider-h6jTd2"};